import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Logo from 'Icons/RMlogo.png';
import { TreeService } from 'business/services/TreeService';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import { getParentPath } from 'utils/Global';
import { createPdfWithPopupBlockerHandler } from './utils';
import { pageSize } from './ReportsConstants';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export async function createCanvasDesignPDFReport(
  imageUri,
  plateId,
  plateBar,
  expId,
  expName,
  saveReport,
  isMultiPlateExperiment,
  onPopupBlocked?: () => void,
) {
  const pageMargins = [30, 50, 30, 30];
  const pdfDefinition = {
    info: {
      title: expName + ' - Canvas Design Report',
      author: 'Rock Maker',
      subject: 'Experiment Design',
    },
    content: CreateContent(imageUri, isMultiPlateExperiment, pageMargins),
    styles: {
      headerText: { fontSize: 8 },
      tableHeader: {
        lineHeight: 1,
        bold: true,
        fontSize: '12',
        alignment: 'center',
        fillColor: '#D9D9D9',
      },
      tableHeaderWithoutMargin: {
        bold: true,
        alignment: 'center',
        margin: [2, 2, 2, 2],
        fillColor: '#cccccc',
      },
      tableSubHeader: { bold: true, fillColor: '#cccccc' },
      termList: { margin: [0, 7, 0, 0] },
    },
    defaultStyle: {
      fontSize: 10,
      lineHeight: 1.5,
    },
    pageMargins: pageMargins,
    header: await getHeader(plateId, plateBar, expId),
    pageBreakBefore: false,
    pageOrientation: 'landscape',
    pageSize: 'A4',
  };

  createPdfWithPopupBlockerHandler(
    pdfMake,
    pdfDefinition,
    expName + ' - Canvas Design Report',
    saveReport,
    onPopupBlocked,
  );
}

function CreateContent(uri, isMultiPlateExperiment, pageMargins) {
  const availableWidth = pageSize.a4.width;
  const availableHeight = pageSize.a4.height - pageMargins[1] - pageMargins[3]; // only add margin top

  return {
    image: uri,
    fit: [availableWidth, availableHeight],
    alignment: 'center',
  };
}

async function getHeader(plateId, plateBar, expId) {
  const treeService = new TreeService();
  const expParents = await treeService.getDocumentParentNodes(
    expId,
    ETreeNodeTypes.Experiment,
    true,
  );
  const expPath = expParents ? getParentPath(expParents) : '';
  const barCode = plateBar.split(',')[2];

  return [
    {
      columns: [
        {
          image: Logo,
          width: 20,
          height: 20,
        },
        {
          text: 'ROCK MAKER®',
          margin: [5, 0, 0, 0],
          width: 100,
        },
        {
          text:
            'Experiment: ' +
            expPath +
            ' PlateID: ' +
            plateId +
            ' Plate Barcode:' +
            barCode,
          style: 'headerText',
        },
      ],
      margin: [20, 20, 20, 10],
    },
  ];
}
